export const WDS_V2_WIDGET_MAP = {
  BUTTON_WIDGET: "WDS_BUTTON_WIDGET",
  INPUT_WIDGET_V2: "WDS_INPUT_WIDGET",
  CHECKBOX_WIDGET: "WDS_CHECKBOX_WIDGET",
  ICON_BUTTON_WIDGET: "WDS_ICON_BUTTON_WIDGET",
  TEXT_WIDGET: "WDS_TEXT_WIDGET",
  TABLE_WIDGET_V2: "WDS_TABLE_WIDGET",
  BUTTON_GROUP_WIDGET: "WDS_BUTTON_GROUP_WIDGET",
  CHECKBOX_GROUP_WIDGET: "WDS_CHECKBOX_GROUP_WIDGET",
};
